import { Component, Input, OnInit } from '@angular/core';
import { ReportService } from '../report.service';
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";
import { DeviceDetectorService } from 'ngx-device-detector';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-project-view',
  templateUrl: './project-view.component.html',
  styleUrls: ['./project-view.component.css']
})
export class ProjectViewComponent implements OnInit {

  @Input('urlData') urlData;
  loadingVisible: boolean;
  popupVisible: boolean;
  dataSource: any = [];
  pdfSrc: any;
  titulo: string;
  subtitulo: string;
  moneda: string;
  constructor(private service: ReportService, public sanitizer: DomSanitizer, private deviceService: DeviceDetectorService) { }

  ngOnInit() {
    this.loadingVisible = true;
    this.service.getDataByUrl(this.urlData).subscribe(resp => {
      this.titulo = resp.titulo;
      this.subtitulo = resp.subtitulo;
      this.moneda = resp.moneda;
      this.loadingVisible = false;
      if(resp.data == undefined) {
        this.dataSource = [];
      } else {
        this.dataSource = resp.data;
      }
    }, err => {
      this.loadingVisible = false;
      notify({
        message: "No se pudo cargar.",
        position: {
            my: "center top",
            at: "center top"
        }
      }, "error", 3000);
    });
  }
  open2(url) {
    //console.log(this.deviceService.isDesktop());
    this.popupVisible = true;
    this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    /*if(!this.deviceService.isDesktop()) {
      window.location.href = url;
    } else {
      this.popupVisible = true;
      this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }*/
    
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/report/project-view/project-view.component.ts